<template>
    <p :class="['paragraph', `paragraph--${props.theme}`]">
        <slot />
    </p>
</template>

<script lang="ts" setup>
    import type { Props } from '@shc/nuxt-shc-ui-layer/components/Paragraph/props'
    import { PARAGRAPH_THEME } from '@shc/nuxt-shc-ui-layer/components/Paragraph/paragraph'

    const props = withDefaults(defineProps<Props>(), {
        theme: PARAGRAPH_THEME.primary,
    })
</script>

<style lang="scss" scoped>
    .paragraph {
        &--primary {
            @apply text-base space-y-6;
        }

        &--secondary {
            @apply text-sm;
        }

        &--tertiary {
            @apply text-xs;
        }

        &--quaternary {
            @apply text-base text-neutral-10;
        }
    }
</style>
